// Reducer for managing dialog, table, and loading state in pending tasks
export const initialState = {
	dialogs: {
		deleteConfirm: false,
		selectedRecord: null,
		// Download popup: the process's ready documents to choose from (only when there are several).
		documentsOpen: false,
		documents: [],
	},
	table: {
		currentPage: 1,
		sortField: "",
		sortDirection: "",
		// True when the sorted column is sorted by its translated label (column config sortByLabel).
		sortByLabel: false,
		searchInput: "",
		startDateInput: "",
		endDateInput: "",
		searchParams: {
			searchTerm: "",
			startDate: "",
			endDate: "",
		},
		recordsPerPage: 10,
	},
	loading: {
		isLoadingBackdrop: false,
	},
};

// Every action that changes which rows match (search, sort, page size) also goes back to page 1,
// here in one place, so no handler has to remember to do it.
export function pendingTaskReducer(state, action) {
	switch (action.type) {
		case "SET_PAGE":
			return {
				...state,
				table: {
					...state.table,
					currentPage: action.payload,
				},
			};
		case "SET_RECORDS_PER_PAGE":
			return {
				...state,
				table: {
					...state.table,
					recordsPerPage: action.payload,
					currentPage: 1,
				},
			};
		case "OPEN_DELETE_DIALOG":
			return {
				...state,
				dialogs: {
					...state.dialogs,
					deleteConfirm: true,
					selectedRecord: action.payload,
				},
			};
		case "CLOSE_DELETE_DIALOG":
			return {
				...state,
				dialogs: {
					...state.dialogs,
					deleteConfirm: false,
					selectedRecord: null,
				},
			};
		case "OPEN_DOCUMENTS_DIALOG":
			return {
				...state,
				dialogs: {
					...state.dialogs,
					documentsOpen: true,
					documents: action.payload,
				},
			};
		case "CLOSE_DOCUMENTS_DIALOG":
			return {
				...state,
				dialogs: {
					...state.dialogs,
					documentsOpen: false,
					documents: [],
				},
			};
		case "SET_SELECTED_RECORD":
			return {
				...state,
				dialogs: {
					...state.dialogs,
					selectedRecord: action.payload,
				},
			};
		case "SET_SORT":
			return {
				...state,
				table: {
					...state.table,
					sortField: action.payload.field,
					sortDirection: action.payload.direction,
					sortByLabel: action.payload.byLabel === true,
					currentPage: 1,
				},
			};
		case "SET_SEARCH_INPUT":
			return {
				...state,
				table: {
					...state.table,
					searchInput: action.payload,
				},
			};
		case "SET_START_DATE_INPUT":
			return {
				...state,
				table: {
					...state.table,
					startDateInput: action.payload,
				},
			};
		case "SET_END_DATE_INPUT":
			return {
				...state,
				table: {
					...state.table,
					endDateInput: action.payload,
				},
			};
		case "SET_SEARCH_PARAMS":
			return {
				...state,
				table: {
					...state.table,
					searchParams: action.payload,
					currentPage: 1,
				},
			};
		case "CLEAR_FILTERS":
			return {
				...state,
				table: {
					...state.table,
					searchInput: initialState.table.searchInput,
					startDateInput: initialState.table.startDateInput,
					endDateInput: initialState.table.endDateInput,
					searchParams: initialState.table.searchParams,
					sortField: initialState.table.sortField,
					sortDirection: initialState.table.sortDirection,
					sortByLabel: initialState.table.sortByLabel,
					currentPage: 1,
				},
			};
		case "SET_LOADING":
			return {
				...state,
				loading: {
					...state.loading,
					[action.payload.key]: action.payload.value,
				},
			};
		default:
			return state;
	}
}
